import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { useTranslate } from '@im/react-localization';
import { SingleRuleTab } from './SingleRuleTab';
import { useGetRuleQuery } from '../hooks/get-rule';
import { CenterLoader } from '@im/ui-lib/CenterLoader';

export default function EditPricingRule() {
  const translate = useTranslate();

  const getRule = useGetRuleQuery({ ruleId: '1' });

  return (
    <Stack p={3}>
      <Typography fontSize={'24px'} fontWeight={'bold'} variant="body2">
        {translate('Pricing.EditPricingRule')}
      </Typography>

      {getRule.data ? (
        <SingleRuleTab initialFormData={getRule.data} isEdit={true} />
      ) : (
        <CenterLoader />
      )}
    </Stack>
  );
}
